export const gallerySocialProviders = [
  {
    value: "instagram",
    label: "Instagram",
  },
  {
    value: "tiktok",
    label: "TikTok",
  },
  {
    value: "youtube",
    label: "YouTube",
  },
  {
    value: "snapchat",
    label: "Snapchat",
  },
];
